import Component from "vue-class-component";
import { mapGetters } from "vuex";
import moment from "moment";
import PatientFormProps from "./PatientFormProps";
import { PatientInterface } from "@/api/Interfaces/PatientInterface";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";
import AlertMessage from "@/components/Util/AlertMessage/AlertMessage.vue";
@Component<PatientFormComponent>({
  name: "PatientForm",
  props: ["patient"],
  components: {
    AlertMessage,
  },

  computed: {
    ...mapGetters(["getCpf", "getPatientData"]),
  },

  watch: {
    formPatientData: {
      handler(formData: any): void {
        this.invalidForm = false;
        this.removeValidations();

        const { name, birthday, sex, email, mkt_terms_accepted } = formData;

        if (name && birthday && sex && email && mkt_terms_accepted) {
          const parsedBirthday = moment(birthday, 'DD/MM/YYYY', true);
          
          if (!parsedBirthday.isValid() || moment().diff(parsedBirthday, 'days') <= 0 || moment().diff(parsedBirthday, 'years') < 18 && moment().diff(parsedBirthday, 'hours') > 0 && !this.incompletePatientInfo || parsedBirthday.year() < 1900) {
            this.preValidation = true;
            this.$emit("isValid", false);
          } else if (!this.emailMatch(email)) {
            this.preValidation = true;
            this.$emit("isValid", false);
          } else {
            this.invalidForm = false;
            this.showMessage = false;
            this.$emit("isValid", true);
          }
        } else {
          this.$emit("isValid", false);
        }
        this.$emit("updateForm", formData);
      },

      deep: true,
    },
    invalidForm(val) {
      this.showMessage = true;
      if (val) this.validateForm();
    },
    incompletePatientInfo(val) {
      if (val) {
        this.showMessage = true;
        this.alertMessage = "Complete seu cadastro para agendar seu horário agora mesmo! Caso precise alterar outro dado não disponível, realize a atualização na clínica.";
        this.alertColor = "#FF9100";
        this.formPatientData = this.getPatientData as any;
        if(this.formPatientData.birthday) {
          const parts = this.formPatientData.birthday.split('-');
          const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
          this.formPatientData.birthday = formattedDate;
        }
      }
    },
    patientEmail(email) {
      this.formPatientData.email = email || this.formPatientData.email;
    }
  },
})
export default class PatientFormComponent extends PatientFormProps {
  getCpf!: string;
  getPatientData!: PatientInterface;

  form = { 
    document: "",
    name: "",
    birthday: "",
    sex: "",
    email: "",
    mkt_terms_accepted: false,
  };

  newPatient = {};
  formPatientData!: PatientInterface;
  patientEmail = "";

  validationNameMessage = "";
  validationBirthdayMessage = "";
  validationGenderMessage = "";
  validationEmailMessage = "";
  validationTerms = false;
  preValidation = false;
  alertMessage = "Complete seu cadastro para agendar seu horário agora mesmo!";
  alertColor = "";
  invalidForm = false;
  showMessage = false;
  minDate = moment().format("YYYY-MM-DD");

  cx_checkboxZipCodeIsActive!: string;
  cx_patient = this.patient;

  constructor() {
    super();
    this.cx_checkboxZipCodeIsActive = "";
    this.cx_patient = this.patient;
    this.formPatientData = this.getPatientData || this.newPatient;
    if(this.formPatientData.birthday) {
      const parts = this.formPatientData.birthday.split('-');
      const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
      this.formPatientData.birthday = formattedDate;
    }
  }

  mounted(): void {
    this.newPatient = (this.notRegisteredPatient && this.notRegisteredPatient.name) ? this.notRegisteredPatient : this.form;
    this.formPatientData = this.getPatientData || this.newPatient;
    this.$emit("setLoading", false);
    this.cx_checkboxZipCodeIsActive = "";
    this.formPatientData.document = this.getCpf;
    if(this.formPatientData.birthday) {
      const parts = this.formPatientData.birthday.split('-');
      const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
      this.formPatientData.birthday = formattedDate;
    }
    this.cx_patient = this.patient;
    GoogleAnalyticsEvents.loadUserRegister();
  }

  updateTerms(): void {
    this.$emit("updateTerms", this.formPatientData.mkt_terms_accepted);
  }

  removeValidations() {
    const { name, birthday, sex, email, mkt_terms_accepted } = this.formPatientData; 

    if (name) this.validationNameMessage = "";
    if (birthday) this.validationBirthdayMessage = "";
    if (sex) this.validationGenderMessage = "";
    if (email) this.validationEmailMessage = "";
    if (mkt_terms_accepted) this.validationTerms = false;
  }

  validateName(name: string) {
    if (!name) this.validationNameMessage = "Campo de preenchimento obrigatório.";
  }

  validateBirthday(birthday: string) {
    this.alertMessage = "Complete seu cadastro para agendar seu horário agora mesmo!";
    this.alertColor = "#FF9100";
    if (!birthday) {
      this.validationBirthdayMessage = "Campo de preenchimento obrigatório.";
    } else {
      const parsedBirthday = moment(birthday, 'DD/MM/YYYY', true);
  
      if (!parsedBirthday.isValid() || moment().diff(parsedBirthday, 'days') <= 0 || parsedBirthday.year() < 1900) {
        this.validationBirthdayMessage = "Informe uma data válida.";
      } else if (moment().diff(parsedBirthday, 'years') < 18 && moment().diff(parsedBirthday, 'hours') > 0 && !this.incompletePatientInfo) {
        this.alertMessage = "Paciente menor de idade. Por favor, faça seu cadastro diretamente da clínica.";
        this.alertColor = "#F04F50";
        this.validationBirthdayMessage = "Paciente menor de idade.";
      }
    }
  }

  validateGender(gender: string) {
    if (!gender) this.validationGenderMessage = "Campo de preenchimento obrigatório.";
  }
  
  validateEmail(email: string) {
    if (!email) {
      this.validationEmailMessage = "Campo de preenchimento obrigatório.";
    } else if (!this.emailMatch(email)) {
      this.validationEmailMessage = "Informe um e-mail válido.";
    }
  }

  validateTerms(mkt_terms_accepted: boolean) {
    if (!mkt_terms_accepted) this.validationTerms = true;
  }

  validateForm() {
    const { name, birthday, sex, email, mkt_terms_accepted } = this.formPatientData; 

    this.validateName(name!);
    this.validateBirthday(birthday!);
    this.validateGender(sex!);
    this.validateEmail(email!);
    this.validateTerms(mkt_terms_accepted!);

    if (this.validationNameMessage, this.validationBirthdayMessage, this.validationGenderMessage, this.validationEmailMessage, this.validationTerms) this.invalidForm = false;
  }

  emailMatch(email: string) {
    return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }

}
